import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";

interface LoanCalculatorState {
  loanDetails: any;
  agreement: string;
  calculationInProgress?: boolean;
  loanDto: any;
}

export const initialState: LoanCalculatorState = {
  loanDetails: {},
  agreement: "",
  loanDto: {}
};

const loanCalculatorSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    showAgreementRequest(state) {
      return state;
    },
    showAgreementSuccess(state, action) {
      state.agreement = action.payload;
    },
    showAgreementFailure(state) {
      return state;
    },
    calculateRequest(state) {
      state.calculationInProgress = true;
    },
    calculateSuccess(state, action) {
      state.loanDetails = action.payload;
      state.calculationInProgress = false;
    },
    calculateFailure(state) {
      state.calculationInProgress = false;
    },
    setLoanDto(state, action) {
      state.loanDto = action.payload;
    },
    destroy() {
      return initialState;
    }
  }
});

export default loanCalculatorSlice.reducer;
export const {
  showAgreementRequest,
  showAgreementSuccess,
  showAgreementFailure,
  calculateRequest,
  calculateSuccess,
  calculateFailure,
  destroy
} = loanCalculatorSlice.actions;
export const loanCalculatorActions = loanCalculatorSlice.actions;
